/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Level
 */
export interface Level {
}

/**
 * Check if a given object implements the Level interface.
 */
export function instanceOfLevel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LevelFromJSON(json: any): Level {
    return LevelFromJSONTyped(json, false);
}

export function LevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Level {
    return json;
}

export function LevelToJSON(value?: Level | null): any {
    return value;
}

